"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACSegmentedElement = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var ACSegmentedElement = function (props) {
    var handleChange = function (value) {
        if (props.onChange) {
            props.onChange(value);
        }
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Segmented, { options: props.options ? props.options : [], onChange: function (val) {
            handleChange(val);
        }, size: props.size, className: "".concat(props.className, "\n      ant-segment-selected"), value: props.value }));
};
exports.ACSegmentedElement = ACSegmentedElement;
